/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DirectoryAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function DirectoryAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/DirectoryAction"
  
}) {
let tabSelectedInstallAppIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.install_app_id',
})
let constantData = 'Directory'
let aggregateData = fromHelpers.getText(tabSelectedInstallAppIdValueData, constantData)
let tabSelectedAppsFilterValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.apps_filter',
})
let constantData1 = 'directory'
let aggregateData1 = fromHelpers.getSelected(tabSelectedAppsFilterValueData, constantData1)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 data="tab.selected.install_app_id"
 data="'Directory'"
 aggregate="helpers.js getText"
 text={aggregateData}
 onClick={onClick}
 data="tab.selected.apps_filter"
 data="'directory'"
 aggregate="helpers.js getSelected"
 isSelected={aggregateData1}
 size="normal"
 color={dtColorsNeutral900}
/>
{children}
</React.Fragment>)
}